import type { City, CityId } from '../types';

/**
 * `trust` is what the city banner says out loud. It is not cosmetic: Hong Kong's
 * listings come from the body that issues halal certificates, while Beijing's
 * come from volunteers who tagged a map. Presenting those identically is the
 * thing this rebuild exists to stop.
 */
export const CITIES: Record<CityId, City> = {
    hongkong: {
        id: 'hongkong',
        name: 'Hong Kong',
        nameLocal: '香港',
        flag: '🇭🇰',
        center: [22.3193, 114.1694],
        cardLanguage: 'chinese',
        trust: 'certified',
        // Article-free and short: this name is embedded mid-sentence in five
        // languages, and a leading English "the" reads as an error inside an
        // Arabic or Turkish clause. The organisation's name itself stays
        // untranslated — it is a proper noun, and it is what the certificate says.
        sourceLabel: 'Islamic Community Fund of Hong Kong',
    },
    paris: {
        id: 'paris',
        name: 'Paris',
        nameLocal: 'Paris',
        flag: '🇫🇷',
        center: [48.8566, 2.3522],
        cardLanguage: 'french',
        trust: 'mixed',
        sourceLabel: 'AVS and OpenStreetMap contributors',
    },
    tokyo: {
        id: 'tokyo',
        name: 'Tokyo',
        nameLocal: '東京',
        flag: '🇯🇵',
        center: [35.6762, 139.6503],
        cardLanguage: 'japanese',
        trust: 'community',
        sourceLabel: 'Minato City open data and OpenStreetMap contributors',
    },
    beijing: {
        id: 'beijing',
        name: 'Beijing',
        nameLocal: '北京',
        flag: '🇨🇳',
        center: [39.9042, 116.4074],
        cardLanguage: 'chinese',
        trust: 'community',
        sourceLabel: 'OpenStreetMap contributors',
    },
    shenzhen: {
        id: 'shenzhen',
        name: 'Shenzhen',
        nameLocal: '深圳',
        flag: '🇨🇳',
        center: [22.5431, 114.0579],
        cardLanguage: 'chinese',
        trust: 'community',
        sourceLabel: 'OpenStreetMap contributors',
    },
};

export const CITY_IDS = Object.keys(CITIES) as CityId[];

export function isCityId(value: string | undefined): value is CityId {
    return !!value && value in CITIES;
}
